if (!customElements.get('pdp-gallery')) {
  class PdpGallery extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.slides = [];
      this.currentSlide = 0;
      this.slideCount = 0;
      this.prevButton = null;
      this.nextButton = null;
      this.blossom = null;
      this.bar = null;
      this.nav = null;
      this.barResizeObserver = null;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._init(), { once: true });
      } else {
        this._init();
      }
    }

    _init() {
      this.carousel = this.querySelector('.pdp-intro__gallery');
      if (!this.carousel) return;

      this.initVideoTriggers();

      this.slides = this.carousel.querySelectorAll('.pdp-intro__gallery-item');
      if (this.slides.length <= 1) return;

      this.slideCount = this.slides.length;
      this.prevButton = document.querySelector(`.pdp-intro__gallery-arrow--prev[data-gallery="${this.id}"]`);
      this.nextButton = document.querySelector(`.pdp-intro__gallery-arrow--next[data-gallery="${this.id}"]`);

      this.initBlossom();
      this.updateArrowStates();

      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      this.carousel.addEventListener('scroll', () => this.onScroll());

      this.observeBarHeight();
    }

    initVideoTriggers() {
      this.querySelectorAll('.pdp-gallery__video-trigger').forEach((trigger) => {
        const player = trigger.nextElementSibling;
        trigger.addEventListener('click', () => player.openFullscreen());
      });
    }

    observeBarHeight() {
      const header = this.closest('.pdp-intro__header');
      this.bar = header?.querySelector('.pdp-intro__bar');
      this.nav = header?.querySelector('.pdp-intro__bar-gallery-nav');
      if (!this.bar || !this.nav) return;

      const setBarHeight = () => {
        this.nav.style.setProperty('--pdp-bar-height', `${this.bar.offsetHeight}px`);
      };

      setBarHeight();
      this.barResizeObserver = new ResizeObserver(setBarHeight);
      this.barResizeObserver.observe(this.bar);
    }

    disconnectedCallback() {
      if (this.barResizeObserver) this.barResizeObserver.disconnect();
      if (this.blossom) this.blossom.destroy();
    }

    initBlossom() {
      if (typeof BlossomCarousel !== 'undefined' && BlossomCarousel.Blossom) {
        this.blossom = BlossomCarousel.Blossom(this.carousel);
        this.blossom.init();
      } else {
        setTimeout(() => {
          if (typeof BlossomCarousel !== 'undefined' && BlossomCarousel.Blossom) {
            this.blossom = BlossomCarousel.Blossom(this.carousel);
            this.blossom.init();
          }
        }, 100);
      }
    }

    onScroll() {
      const scrollLeft = this.carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.slides.forEach((slide, index) => {
        const distance = Math.abs(this.slideOffset(slide) - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.currentSlide = closestIndex;
      this.updateArrowStates();
    }

    slideOffset(slide) {
      return slide.offsetLeft - this.carousel.offsetLeft;
    }

    updateArrowStates() {
      if (this.prevButton) this.prevButton.disabled = this.currentSlide === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentSlide >= this.slideCount - 1;
    }

    prev() {
      if (!this.carousel || this.currentSlide === 0) return;
      this.currentSlide--;
      this.scrollToSlide(this.currentSlide);
    }

    next() {
      if (!this.carousel || this.currentSlide >= this.slideCount - 1) return;
      this.currentSlide++;
      this.scrollToSlide(this.currentSlide);
    }

    scrollToSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.carousel.scrollTo({ left: this.slideOffset(slide), behavior: 'smooth' });
      this.updateArrowStates();
    }
  }

  customElements.define('pdp-gallery', PdpGallery);
}
